import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { RestfullApiService } from "../config/service";
import { Link, useNavigate } from "react-router-dom";
import { MEDIA_URL } from "../config/url";
import { encryptData } from "../utils/storage";
import { useSelector } from "react-redux";
import { removeSpace } from "../utils";

const Review = () => {
  const user = useSelector((state) => state.user.userProfile);
  // const user = JSON.parse(localStorage.getItem("userProf"));

  const navigate = useNavigate();

  const [reviewData, setReviewData] = useState([]);

  async function ReviewHandle() {
    const reqdata = {
      Method_Name: "MyReview",
      Review_Id: "",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
    };

    console.log("Request Data:", reqdata);

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/Profile_get"
      );
      console.log("API Response:", result);

      if (result) {
        setReviewData(result?.data?.Result.Table1);
        console.log(result);
        return result;
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.response?.data?.message);
    }
  }

  const navigateToEvent = (nav, displayName) => {
    navigate(`/event-details/${removeSpace(displayName)}/${nav}`);
  };

  useEffect(() => {
    ReviewHandle();
  }, []);

  return (
    <>
      <div className="row y-gap-20 justify-between items-end lg:pb-20 md:pb-10">
        <div className="col-auto pl-46 pt-20 lg:pl-20">
          <h1 className="text-20 lh-14 fw-600">
            Hi 👋 {user?.First_Name} !{" "}
            <span className="text-primary">
              Your feedback matters… Rate and share your event experience!
            </span>
          </h1>
        </div>
        <div className="col-auto"></div>
      </div>
      {reviewData?.length < 1 ? (
        <div className="py-30 px-30 rounded-4 bg-white">
          <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
            <div className="col-auto">
              <h1 className="text-20 text-primary lh-14 fw-600">
                No Reviews from You Yet?
              </h1>
              <p className="text-13 fw-500">
                We'd love to hear about your experiences! Share your thoughts
                and help others find their next great marathon!
              </p>
            </div>
            <div className="col-auto"></div>
          </div>
        </div>
      ) : (
        <div className="py-30 px-30 rounded-4 bg-white lg:px-0 lg:pt-0">
          <div className="row y-gap-30">
            {reviewData.map((list) => {
              const encryptedParam = encryptData(list?.Event_Id);
              var arraytypevent = list.Event_Category_List?.split(",");
              return (
                <div
                  key={list.Event_Id}
                  className="col-xl-12 col-lg-12 col-sm-12"
                >
                  <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
                    <div className="eventsCard__content">
                      <div className="row items-center">
                        <div className="col-xl-3 col-lg-3 col-sm-6">
                          <div className="cardImage ratio ratio-2:1">
                            <div className="cardImage__content rounded-8">
                              <img
                                className="rounded-16 col-12"
                                src={`${MEDIA_URL}${list.Image_Path}`}
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6">
                          <h4 className="eventsCard__title text-dark-1 pb-15 font-inter text-18 lh-13 fw-600 lg:mt-25">
                            <Link
                              component="button"
                              underline="none"
                              onClick={() =>
                                navigateToEvent(
                                  encryptedParam,
                                  list.Display_Name
                                )
                              }
                            >
                              <span className="trim-2">
                                {list.Display_Name}
                              </span>
                            </Link>
                          </h4>
                          <div className="mt-15 lg:mt-0">
                            <span className="text-reading lh-14 font-inter text-14 fw-500 mt-5 md:d-block lg:mb-5">
                              <i className="fas fa-map-marker-alt text-primary text-15 fw-600 "></i>{" "}
                              <span className="text-reading font-inter">
                                {list?.City_Name}, {list?.State}
                              </span>
                            </span>
                            <span className="text-reading lh-14 font-inter text-14 fw-500 mt-5 ml-10 lg:ml-0 lg:mt-15">
                              <i className="fas fa-running text-primary text-15 fw-600"></i>{" "}
                              <span className="text-reading">
                                {list.EventType_Name}
                              </span>
                            </span>
                            <span className="text-light-1 lh-14 text-14 fw-600 mt-5 ml-30 lg:mt-10">
                              {list?.Rating === 0 ? (
                                <></>
                              ) : (
                                <>
                                  <i className="fas fa-star text-green text-15 fw-600"></i>{" "}
                                  <span>{list.Rating}</span>
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-sm-6">
                          <div className="d-flex flex-wrap justify-end lg:justify-start items-center mt-10">
                            {/* {list.Event_Category_List.split(",").map(
                              (category, index) => (
                                <div
                                  key={index}
                                  className="bg-light-2 rounded-16 text-12 fw-600 text-dark-1 py-5 px-15 lh-1 uppercase mr-5 mb-5"
                                >
                                  {category}
                                </div>
                              )
                            )} */}

                            {arraytypevent
                              ?.slice(0, 3)
                              .map((datatype, index) => (
                                <div key={`ML${index}`} className="col-auto">
                                  <div className="bg-light-2 font-inter rounded-16 text-12 fw-600 text-dark-1 py-5 px-15 lh-1 uppercase mr-5 mb-5">
                                    {datatype.toUpperCase()}
                                  </div>
                                </div>
                              ))}
                            {arraytypevent?.length > 3 && (
                              <div className="col-auto text-10 fw-500 text-light underline">
                                <Link
                                  to={`/event-details/${removeSpace(
                                    list.Display_Name
                                  )}/${encryptedParam}`}
                                >
                                  +{arraytypevent.length - 3} MORE..
                                </Link>
                              </div>
                            )}
                          </div>

                          <div className="mt-20 md:mt-0 pb-5 d-flex flex-column flex-md-row justify-between align-items-start">
                            <p className="text-12 font-inter fw-500 mt-8 mb-2 mb-md-0">
                              <span>Registered On : </span>
                              <span className="text-primary">
                                {list.Registration_Date.split("/").join(" ")}
                              </span>
                            </p>
                            <button className="button border-primary -primary-1 text-primary rounded-25 text-12 px-20 py-10">
                              <Link
                                to={`/event-reviews/${encryptedParam}/${encryptData(
                                  "write"
                                )}`}
                              >
                                Write a Review
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Review;
